import {createSlice, createAsyncThunk} from '@reduxjs/toolkit'
import axios from 'axios'
const api = '/api/'

export const ListTransportPayment = createAsyncThunk(
  'student-transport-payments-list',
  async (params: {}, thunkAPI) => {
    try {
      const response = await axios.get(`${api}student-transport-payments/list`, params)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const paymentsSummary = createAsyncThunk('payments-summary', async (_, thunkAPI) => {
  try {
    const response = await axios.get(`${api}student-transport-payments/payments-summary`)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

// Get Transport StudentList
export const ListTransportStudent = createAsyncThunk(
  'student-transport-payments-list',
  async (_, thunkAPI) => {
    try {
      const response = await axios.get(
        `${api}student-transport-payments/get-students-has-transport`
      )
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const getTransportPaymentDetails = createAsyncThunk(
  'student-transport-payments-details',
  async (student_id: any, thunkAPI) => {
    try {
      const response = await axios.get(
        `${api}student-transport-payments/student-details/` + student_id
      )
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data)
      }
    }
  }
)

export const transportPaymentStore = createAsyncThunk(
  'student-transport-payments-store',
  async (companyData: any, thunkAPI) => {
    try {
      const {data} = await axios.post(`${api}student-transport-payments/store`, companyData)
      return data
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error.response?.data?.errors)
    }
  }
)

export const editTransportPayment = createAsyncThunk(
  'student-transport-payments-edit',
  async (id: string, thunkAPI) => {
    try {
      const response = await axios.get(`/api/student-transport-payments/edit/${id}`)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const studentPayments = createAsyncThunk(
  'student-transport-payments',
  async (params: {student_id: string; year: string}, thunkAPI) => {
    try {
      const response = await axios.get(
        `${api}student-transport-payments/student-transport-payments`,
        {
          params, // ✅ correct axios GET params
        }
      )
      return response.data
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error.response?.data?.errors)
    }
  }
)

export const printTransportPayment = createAsyncThunk(
  'student-transport-payments-print',
  async (id: string, thunkAPI) => {
    try {
      const response = await axios.get(`${api}student-transport-payments/print/${id}`)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const deleteTransportPayment = createAsyncThunk(
  'student-transport-payments-delete',
  async (id: string, thunkAPI) => {
    try {
      await axios.get(`${api}student-transport-payments/delete/${id}`)
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

type TransportPaymentState = {
  errors: any
}

const initialState: TransportPaymentState = {
  errors: '',
}

export const studentTransportPayments = createSlice({
  name: 'transport_payments',
  initialState,
  reducers: {
    reset: () => initialState,
  },
  extraReducers: (builder) => {},
})

export const {reset} = studentTransportPayments.actions
export default studentTransportPayments.reducer
